import React from 'react';

export default function IconArrowRight(props){
    return (
        <svg {...props} className={props.className} viewBox="0 0 18 33" enableBackground="new 0 0 18 33"><path fillRule="evenodd" d="M15.975,0.344 C16.206,0.116 16.496,0.002 16.814,0.002 C17.133,0.002 17.422,0.116 17.654,0.344 C18.117,0.798 18.117,1.538 17.654,1.993 L2.891,16.502 L17.654,31.012 C18.117,31.466 18.117,32.206 17.654,32.661 C17.190,33.116 16.438,33.116 15.975,32.661 L0.373,17.327 C-0.090,16.872 -0.090,16.131 0.373,15.678 L15.975,0.344 Z"/></svg>
    );
}